module.exports = __webpack_public_path__ + "img/chofu_etc_off.e1f98cab.svg";